<template>
    <div class="statistica__item">
            <div class="statistica__item-title">Прогнозируемый доход</div>
            <div class="statistica__forecast">
                <div class="statistica__forecast-item">
                    <div class="statistica__forecast-item-title">
                        <div class="statistica__forecast-item-title-period">неделя</div>
                        <!--<div class="statistica__forecast-item-title-date">с 21.01.2018 по 21.01.2018</div>-->
                    </div>
                    <div class="statistica__forecast-item-data">
                        <div class="statistica__forecast-item-data-sum">$ {{Math.ceil(prognosis.week).toLocaleString('en')}}</div>
                        <div class="statistica__forecast-item-data-pips">(+{{percentWeek}}%)</div>
                        <div class="statistica__forecast-item-data-probability">
                            вероятность 98%
                        </div>
                    </div>
                </div>
                <div class="statistica__forecast-item">
                    <div class="statistica__forecast-item-title">
                        <div class="statistica__forecast-item-title-period">месяц</div>
                        <!--<div class="statistica__forecast-item-title-date">с 21.01.2018 по 21.01.2018</div>-->
                    </div>
                    <div class="statistica__forecast-item-data">
                        <div class="statistica__forecast-item-data-sum">$ {{Math.ceil(prognosis.month).toLocaleString('en')}}</div>
                        <div class="statistica__forecast-item-data-pips">(+{{percentMonth}}%)</div>
                        <div class="statistica__forecast-item-data-probability">
                            вероятность 96%
                        </div>
                    </div>
                </div>
                <div class="statistica__forecast-item">
                    <div class="statistica__forecast-item-title">
                        <div class="statistica__forecast-item-title-period">3 месяца</div>
                        <!--<div class="statistica__forecast-item-title-date">с 21.01.2018 по 21.01.2018</div>-->
                    </div>
                    <div class="statistica__forecast-item-data">
                        <div class="statistica__forecast-item-data-sum">$ {{Math.ceil(prognosis.sison).toLocaleString('en')}}</div>
                        <div class="statistica__forecast-item-data-pips">(+{{percentSison}}%)</div>
                        <div class="statistica__forecast-item-data-probability">
                            вероятность 96%
                        </div>
                    </div>
                </div>
                <div class="statistica__forecast-item">
                    <div class="statistica__forecast-item-title">
                        <div class="statistica__forecast-item-title-period">6 месяцев</div>
                        <!--<div class="statistica__forecast-item-title-date">с 21.01.2018 по 21.01.2018</div>-->
                    </div>
                    <div class="statistica__forecast-item-data">
                        <div class="statistica__forecast-item-data-sum">$ {{Math.ceil(prognosis.sixmonth).toLocaleString('en')}}</div>
                        <div class="statistica__forecast-item-data-pips">(+{{percentSixmonth}}%)</div>
                        <div class="statistica__forecast-item-data-probability">
                            вероятность 91%
                        </div>
                    </div>
                </div>
                <div class="statistica__forecast-item">
                    <div class="statistica__forecast-item-title">
                        <div class="statistica__forecast-item-title-period">1 год</div>
                        <!--<div class="statistica__forecast-item-title-date">с 21.01.2018 по 21.01.2018</div>-->
                    </div>
                    <div class="statistica__forecast-item-data">
                        <div class="statistica__forecast-item-data-sum">$ {{Math.ceil(prognosis.year).toLocaleString('en')}}</div>
                        <div class="statistica__forecast-item-data-pips">(+{{percentYear}}%)</div>
                        <div class="statistica__forecast-item-data-probability">
                            вероятность 86%
                        </div>
                    </div>
                </div>
            </div>
           </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    data() {
        return {
            prognosis: {
                week:0,
                month:0,
                sison:0,
                sixmonth:0,
                year:0
            },
            percentWeek:0,
            percentMonth:0,
            percentSison:0,
            percentSixmonth:0,
            percentYear:0
        }
    },
    computed : {
         ...mapGetters ({
            getCropStat: 'accountstat/getStatistics'
        }),
    },
    methods : {
        updateData() {
            let stat = this.getCropStat('');
            if (!stat) {
                return;
            }
          this.prognosis = {
               week: stat.Summary.Equity + (stat.Summary.Equity - 100000)*7/stat.DailyRecords.length,
               month: stat.Summary.Equity + (stat.Summary.Equity - 100000)*30/stat.DailyRecords.length,
               sison: stat.Summary.Equity + (stat.Summary.Equity - 100000)*90/stat.DailyRecords.length,
               sixmonth:stat.Summary.Equity + (stat.Summary.Equity - 100000)*180/stat.DailyRecords.length,
               year:stat.Summary.Equity + (stat.Summary.Equity - 100000)*365/stat.DailyRecords.length
            }
            this.percentWeek = ((this.prognosis.week - stat.Summary.Equity) / (stat.Summary.Equity/100)).toFixed(2);
            this.percentMonth = ((this.prognosis.month - stat.Summary.Equity) / (stat.Summary.Equity/100)).toFixed(2);
            this.percentSison = ((this.prognosis.sison - stat.Summary.Equity) / (stat.Summary.Equity/100)).toFixed(2);
            this.percentSixmonth = ((this.prognosis.sixmonth - stat.Summary.Equity) / (stat.Summary.Equity/100)).toFixed(2);
            this.percentYear = ((this.prognosis.year - stat.Summary.Equity) / (stat.Summary.Equity/100)).toFixed(2);
        }
    },
    created() {
       subscribeOnUpdate(this.$store, this.symbol, isFirstObtained => {
            this.updateData();
        });
        this.updateData();
    }
   
}
    
function subscribeOnUpdate(store, symbol, handler) {
    store.dispatch("accountstat/subscribeOnUpdate", {
        symbol: '',
        callback: {
            id: `profit-prognosis-table`,
            handler: handler
        }
    });
}
</script>
<style lang="less" scoped>
.statistica__item {
    background-color: #324258;
    border-radius: 4px;
    width: 912px;
    margin-top: 40px;
    overflow: hidden;
    &-title {
        font-family: Montserrat;
        font-size: 16px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 3;
        letter-spacing: 0.4px;
        color: #ffffff;
        text-transform: uppercase;
        padding-left: 12px;
    }
}

.statistica__forecast {
    background: #3d536b;
    border-radius: 4px;
    display: flex;
    justify-content: space-between;

    &-item {
        flex-basis: 20%;
        border-right: 1px solid #324258;
        flex-grow: 1;
    &-title {
            padding: 8px 0;
            border-bottom: 1px solid #374b62;
        &-period {
            font-family: Arimo;
            font-size: 10px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 2;
            letter-spacing: 0.4px;
            text-transform: uppercase;
            padding-left: 12px;
            color: #ffffff;
        }
        &-date {
            font-family: Arimo;
            font-size: 10px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 2;
            letter-spacing: 0.4px;
            text-transform: uppercase;
            padding-left: 12px;
            color: #aabed2;
        }
    }
    &-data {
        padding: 12px 12px 8px 12px;

        &-sum {
            font-family: Arimo;
            font-size: 16px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.25;
            letter-spacing: 0.4px;
            text-align: left;
            color: #00ffd0;
        }

        &-pips {
            font-family: Arimo;
            font-size: 16px;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.25;
            letter-spacing: 0.4px;
            text-align: left;
            color: #00ffd0;
        }

        &-probability {
            font-family: Arimo;
            font-size: 10px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 2;
            letter-spacing: 0.4px;
            text-transform: uppercase;
            color: #00ffd0;
            margin-top: 8px;
        }
    }
    }
}
</style>

